import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { FETCH_DATA_CENTER } from "../constants/ActionTypes";
import request from "../util/request";
import { fetch_datacenter_details_success } from "actions/DataCenter";

export function* fetch_datacenter_details_action() {
  yield takeLatest(FETCH_DATA_CENTER, fetch_datacenter_saga);
}

function* fetch_datacenter_saga() {
  try {
    let path = [
      // "/datacenter/getAllPastRecordingDevices",
      "/datacenter/getAllRecordingDevicesOfPatients",
      // "/datacenter/getAllPastRecordingDevicesOfPatients",
      // "/datacenter/getAllRecordingNightsCount",
      //   "/datacenter/getAllRecordingDevices",
    ];
    const response = yield all(
      path.map((p) =>
        call(request, {
          path: p,
          method: "GET",
        })
      )
    );
    //Grouping the array Device wise
    // const getDeviceData = (array) => {
    //   array = array.reduce((objectsByKeyValue, obj) => {
    //     const value = obj["device_id"];
    //     objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    //     return objectsByKeyValue;
    //   }, {});
    //   return array;
    // };

    // const getData = (array) => {
    //   let newData = [];
    //   //Grouping the response array Date wise
    //   array = array.reduce((objectsByKeyValue, obj) => {
    //     const value = obj["recording_date"];
    //     objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    //     return objectsByKeyValue;
    //   }, {});
    //   Object.keys(array).map((res) => {
    //     //Check for duplicate devices on a single night recording
    //     if (array[res].length > 1) {
    //       let ids = array[res].map((id) => {
    //         return id.device_id;
    //       });
    //       let duplicates = ids.some((element, index) => {
    //         return ids.indexOf(element) !== index;
    //       });
    //       if (duplicates) {
    //         //Grouping device recordings on device_id for single night
    //         array[res].sort((a, b) => a.rid - b.rid);
    //         let devices = getDeviceData(array[res]);
    //         Object.keys(devices).map((device) => {
    //           //if duplicate found create single object for n objects for single device
    //           if (devices[device].length > 1) {
    //             let tempObj = {};
    //             let initial = devices[device][0];
    //             tempObj.recordingData = devices[device];
    //             tempObj.device_allocation_date = initial.device_allocation_date;
    //             tempObj.device_deallocation_date =
    //               initial.device_deallocation_date;
    //             tempObj.device_id = initial.device_id;
    //             tempObj.email_id = initial.email_id;
    //             tempObj.patient_code = initial.patient_code;
    //             tempObj.recording_date = initial.recording_date;
    //             tempObj.recording_start_time = initial.recording_start_time;
    //             tempObj.timezone = initial.timezone;
    //             tempObj.good_signal_duration = 0;
    //             tempObj.total_bed_time = 0;
    //             devices[device].map((rd) => {
    //               let gsd = !isNaN(rd.good_signal_duration)
    //                 ? JSON.parse(rd.good_signal_duration)
    //                 : 0;
    //               let tbt = !isNaN(rd.total_bed_time)
    //                 ? JSON.parse(rd.total_bed_time)
    //                 : 0;
    //               tempObj.recording_stop_time = rd.recording_stop_time;
    //               tempObj.good_signal_duration += gsd;
    //               tempObj.total_bed_time += tbt;
    //               return 0;
    //             });
    //             newData.push(tempObj);
    //           } else {
    //             //if no duplicate device records are found
    //             newData.push(devices[device][0]);
    //           }
    //           return 0;
    //         });
    //       } else {
    //         //if no duplicate found for single night
    //         array[res].forEach((obj) => {
    //           newData.push(obj);
    //         });
    //       }
    //     } else {
    //       //if only one recording for single night
    //       newData.push(array[res][0]);
    //     }
    //     return 0;
    //   });
    //   //to arrange the array in ascending order
    //   return newData.reverse();
    // };

    // response[5] = response[1];
    // response[1] = getData(response[1]);
    response[1] = response[0];

    if (response) yield put(fetch_datacenter_details_success(response));
  } catch (error) {
    console.error(error);
  }
}

export default function* rootSaga() {
  yield all([fork(fetch_datacenter_details_action)]);
}
